<template>
  <validation-observer
    v-if="isCoverTypeHadContents"
    v-slot="allRisksUnspecifiedObserver"
    slim
  >
    <form-section
      id="all-risks-unspecified"
      v-bind="allRisksUnspecifiedObserver"
      :validated="formObserver.validated"
    >
      <form-row
        label="Would you like to insure any personal possessions you take away from your home? (Items under £1000)"
        :error="formObserver.validated && !allRisksUnspecifiedObserver.valid"
      >
        <div>
          <validation-provider
            v-slot="{ failed }"
            name="Is All Risks Unspecified"
            :vid="`${stepId}_all-risks-unspecified`"
            :rules="{ required: isCoverTypeHadContents }"
            slim
          >
            <radio
              v-model="allRisksUnspecifiedModel"
              name="is-all-risks-unspecified"
              wide
              :error="failed"
              :items="constants.YES_NO"
              :data-test="snakeCase(questionFields.allRisksUnspecified)"
            />
          </validation-provider>
          <validation-provider
            v-if="allRisksUnspecifiedModel"
            v-slot="{ failed, errors }"
            name="All Risks Unspecified"
            :vid="`${stepId}_all-risks-unspecified`"
            rules="listOptionRequired"
            slim
          >
            <qz-select
              v-model="questionData.allRisksUnspecified"
              :items="allRisksUnspecifiedItems"
              :error="failed"
              :error-messages="errors"
              placeholder="Please select value"
              item-text="text"
              class="mt-4"
              :data-test="`${snakeCase(questionFields.allRisksUnspecified)}_other`"
            />
          </validation-provider>
        </div>
      </form-row>
      <help-text
        :error="formObserver.validated && !allRisksUnspecifiedObserver.valid"
      >
        <p>
          If you select yes, this is the <span class="text-decoration-underline">total</span> amount for the things that you would usually take out with you e.g. your phone, handbag or wallet.
        </p>
        <p>
          (You don't need to include the items you have already told us about above).
        </p>
      </help-text>
    </form-section>
  </validation-observer>
</template>

<script>
import QuestionBase from '@/components/questions/Base';

import {
  CONTENT,
} from '@/payloadTemplates/home';

import {
  omit,
} from 'lodash';

export default {
  name: 'question-all-risks-unspecified',
  extends: QuestionBase,
  data () {
    return {
      fields: ['allRisksUnspecified'],
    };
  },
  created () {
    if (!this.isCoverTypeHadContents) {
      this.questionData.allRisksUnspecified = CONTENT.allRisksUnspecified;
    }
  },
  computed: {
    isCoverTypeHadContents () {
      const type = this.formData.home.propertyCoverType;
      return type === 'BC' || type === 'C';
    },

    allRisksUnspecifiedModel: {
      get () {
        const { allRisksUnspecified } = this.stepData;
        if (allRisksUnspecified === null) return null;
        if (allRisksUnspecified === 0) return false;
        return true;
      },
      set (val) {
        this.questionData.allRisksUnspecified = val ? '' : 0;
      },
    },

    allRisksUnspecifiedItems () {
      return this.helpers.createOptions({ source: omit(this.constants.COVER_ALL_RISKS_UNSPECIFIED, this.constants.COVER_ALL_RISKS_UNSPECIFIED_FAVORITES), asNumbers: true });
    },
  },
};
</script>
